// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"Dashboard_Dashboard__jFBog","CategoryWrapper":"Dashboard_CategoryWrapper__1Oi2x","Menu":"Dashboard_Menu__3WuUU"};